import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroupDirective, NgForm, Validators} from "@angular/forms";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ErrorStateMatcher} from "@angular/material/core";
import {UsefulFunctionsService} from "../useful-functions.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  apiKeyFormControl = new FormControl('', [
    Validators.required,
    //TODO LATER create a custom validator for cheking the id validity source : https://angular.io/guide/form-validation#defining-custom-validators
  ]);

  error = null
  environmentApiKey: any;
  disabled: boolean

  constructor(public httpClient: HttpClient,
              public usefulFunctionsService: UsefulFunctionsService) { }

  ngOnInit(): void {

    this.environmentApiKey = sessionStorage.getItem("id")
  }

  /**
   * Manage the form submission
   */
  async onSubmit() {

    this.error = null

    var tokenData: any = await this.httpClient.post(environment.apiUrl+"temptoken", {"id":this.apiKeyFormControl.value}).toPromise().catch(err => {
      this.error = err.error.message
    })

    //If we can retrieve a token from the id written we pass id into the sessionStorage and the local variable that is using it on the page
    if (!this.error && tokenData) {
      sessionStorage.setItem("id", this.apiKeyFormControl.value);
      this.environmentApiKey = this.apiKeyFormControl.value
    }

  }

}
